.root {
  pointer-events: none;
  cursor: not-allowed !important;
  opacity: 0.65 !important;
  filter: grayscale(1);
}
